import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage';
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_SERBIA_Cylindercentre_04 from '../../../assets/CylinderCentre/HANSA_FLEX_SERBIA_Cylindercentre_04.webp'
import imgHANSA_FLEX__BRANCH_SERBIA_UZICE from '../../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_UZICE.webp'
import imgUzice1 from '../../../assets/Branch/uzice/Uzice1.jpg'
import imgUzice2 from '../../../assets/Branch/uzice/Uzice2.jpg'
import imgUzice3 from '../../../assets/Branch/uzice/Uzice3.jpg'
import imgUzice4 from '../../../assets/Branch/uzice/Uzice4.jpg'

const Branch8 = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const carouselData = [

        {
            image: imgUzice1,
        },
        {
            image: imgUzice2,
        },
        {
            image: imgUzice3,
        },
        {
            image: imgUzice4,
        },


    ]
    return (
        <div><CenterStage imageSrc={imgHANSA_FLEX__BRANCH_SERBIA_UZICE} title={"Welcome to HANSA-FLEX Užice"} paragraph={"Opened in 2023 with the intention to be closer to the customers from South Western Serbia, branch Užice has very quickly attracted many customers from different fields, from construction, services, factories and many others. Just like the larger branches, this smaller one can fully service any customer whatever the problem is."}
            buttonName={"Contact us"} buttonLink={"/contact-us"}
        />

            <ThreeDImageCarousel items={carouselData} />

            <div className="text-center div-gray">
                <br /><br />
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>
        </div>
    )
}

export default Branch8